'use client'

import { timezoneDateTime } from '@/helpers/datetime'
import { getMainSession } from '@/helpers/events'
import dayjs from '@/lib/dayjs'
import Link from 'next/link'
import React from 'react'
import CalendarEventCard from './calendar-event-card'

export default function DriverCalendarWeek({ events, weekBeginning, session }) {
  const weekBeginningDayIndex = parseInt(weekBeginning) || 0
  let eventsInRange = []
  if (events && events?.length > 0) {
    eventsInRange = events.filter((event) => {
      let mainSession = getMainSession({ event: event })
      if (!mainSession) return

      let sessionTime = timezoneDateTime({
        datetime: mainSession.targetDateTime,
        timezone: mainSession.targetTimezone,
        format: false,
      })

      return sessionTime.isBetween(
        dayjs().weekday(weekBeginningDayIndex),
        dayjs().weekday(weekBeginningDayIndex + 6),
      )
    })
  }

  function convertDayIndex(dayIndex) {
    // If the day is Sunday (0), return 6 (Sunday in the new format)
    if (dayIndex === 0) {
      return 6
    }
    // Otherwise, subtract 1 from the day index to shift the days forward by one
    else {
      return dayIndex - 1
    }
  }

  function getEventsForDayIndex({ dayIndex }) {
    return eventsInRange.filter(
      (event) =>
        convertDayIndex(
          timezoneDateTime({
            datetime: getMainSession({ event: event }).targetDateTime,
            timezone: getMainSession({ event: event }).targetTimezone,
            format: false,
          }).day(),
        ) === dayIndex,
    )
  }

  return (
    <div className="relative mt-6 h-full">
      <div className="h-auto w-full lg:col-start-2">
        {eventsInRange.length === 0 ? (
          <div className="my-6 flex flex-col items-baseline justify-between gap-4 rounded-sm border border-neutral-blue-700 bg-neutral-blue-700 px-8 py-10">
            <h5 className="text-shades-0lg:text-h-5 font-inter text-h-6 font-medium">
              {dayjs().weekday(weekBeginningDayIndex).format('dddd DD MMMM')} -{' '}
              {dayjs()
                .weekday(weekBeginningDayIndex + 6)
                .format('dddd DD MMMM')}
            </h5>
            <p className="font-inter text-p-3 font-semibold text-neutral-blue-500">
              No events this week.{' '}
            </p>
            <Link
              href="/sim-racing-events"
              className="ml-[5px] hidden cursor-pointer font-inter font-normal text-shades-0 underline underline-offset-2 lg:inline-block"
            >
              Find an event
            </Link>
          </div>
        ) : (
          <>
            {[0, 1, 2, 3, 4, 5, 6].map((index) => (
              <div
                key={`event-cards-day-${index}`}
                className="flex flex-col gap-6"
              >
                <h5 className="font-inter text-h-5 font-medium">
                  {dayjs()
                    .weekday(weekBeginningDayIndex + index)
                    .format('dddd DD MMMM')}
                </h5>
                {/*Check if any events are scheduled for the day*/}
                {getEventsForDayIndex({ dayIndex: index }).length === 0 ? (
                  <div className="flex items-baseline justify-between gap-4">
                    <p className="font-inter text-p-3 font-semibold text-neutral-blue-500">
                      No events.{' '}
                      <Link
                        href="/sim-racing-events"
                        className="ml-[5px] hidden cursor-pointer font-inter font-normal text-shades-0 underline underline-offset-2 lg:inline-block"
                      >
                        Find an event
                      </Link>
                    </p>
                  </div>
                ) : (
                  getEventsForDayIndex({ dayIndex: index }).map((event, i) => (
                    <React.Fragment key={`event-${event.id}-${i}`}>
                      <CalendarEventCard event={event} session={session} />
                    </React.Fragment>
                  ))
                )}
                <div className="divider m-0 mb-6" />
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  )
}
